
@if (description()?.[translate.currentLang]){
  <section class="details-page__description">
    <h3 
      class="ci-heading-h3-s-bold details-page__title">
      {{ 'Descripción' | translate }}
    </h3>
    <div
      class="ci-paragraph-p3-regular description__text"
      [innerHTML]="description()[translate.currentLang]"></div>
  </section>
}